import {
  Avatar,
  Box,
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles
} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import { InsertDriveFile } from "@material-ui/icons";
import ImageSearch from "@material-ui/icons/ImageSearch";
import React from "react";
import { useDispatch } from "react-redux";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";
import List from "react-virtualized/dist/commonjs/List";
import { accessoriesActions } from "../../actions/accessories.actions";
import MenuActions from "../MenuActions";
import ValidationModal from "../ValidationModal";
import { accessoryCategoriesActions } from "../../actions/accessoryCategories.actions";

const useStyles = makeStyles((theme) => ({
  textSecondary: {
    color: "rgba(0, 0, 0, 0.54)",
  },
}));

export default function AccessoriesList(props) {
  const classes = useStyles();
  const [selectedAccessory, setSelectedAccessory] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [deleting, setDeleting] = React.useState(false);
  const dispatch = useDispatch();

  const handleCloseMenuList = (option, accessory) => {
    if (option === "Supprimer") {
      setSelectedAccessory(accessory);
      setOpenModal(true);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAccessoryDelete = () => {
    setDeleting(true);

    dispatch(accessoriesActions.disable(selectedAccessory.id)).then(() => {
      setDeleting(false);
      setOpenModal(false);
    });
    dispatch(accessoryCategoriesActions.fetchAccessoryCategoriesIfNeeded());
  };


  const _noRowsRenderer = () => {
    return (
      <div style={{ listStyle: "none" }}>
        <ListItem button style={{ height: "80px" }}>
          <ListItemText
            disableTypography
            primary={
              <Typography style={{ textAlign: "center" }}>
                Aucun accessoire trouvé
              </Typography>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
      </div>
    );
  };

  const _rowRenderer = ({ index, key, style }) => {
    const accessory = props.accessories[index];

    return (
      <div key={key} style={{ ...style, listStyle: "none" }}>
        <ListItem
          button
          style={{ height: "80px", listStyle: "none", paddingRight: "75px" }}
        >
          <ListItemAvatar>
            {accessory.image && (
              <Avatar
                variant={"square"}
                imgProps={{
                  style: {
                    objectFit: "contain",
                  },
                }}
                src={process.env.REACT_APP_API_URL + accessory.image.contentUrl}
              />
            )}
            {!accessory.image && (
              <Avatar>
                <ImageSearch />
              </Avatar>
            )}
          </ListItemAvatar>
          <ListItemText
            disableTypography
            primary={<Typography>{accessory.name}</Typography>}
            secondary={
              <Box display="flex">
                <Grid className={classes.textSecondary} container>
                  <Grid item xs={4}>
                    <Typography variant={"body2"}>
                      {accessory.reference}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Chip
                      variant="outlined"
                      color="primary"
                      size="small"
                      label={accessory.autoCalc ? "Automatique" : "Manuel"}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant={"body2"}>
                        {accessory.category?.name || ''}
                      </Typography>
                  </Grid>
                  {accessory.enabled === false && (
                    <Grid item xs={4}>
                      <Chip
                        size="small"
                        label="Inactif"
                        style={{ backgroundColor: "#ffcdd2", color: "#b71c1c" }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            }
          />
          {accessory.pdf && (
            <InsertDriveFile color="primary" fontSize="medium" />
          )}
          <ListItemSecondaryAction>
            <MenuActions
              onClose={(option) => handleCloseMenuList(option, accessory)}
              options={{
                show: {
                  name: "Voir",
                  link: `/renov/accessories/${accessory.id}/show`,
                },
                edit: {
                  name: "Editer",
                  link: `/renov/accessories/${accessory.id}/edit`,
                },
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
        <Divider variant="inset" component="li" />
      </div>
    );
  };

  return (
    <div
      style={{
        height: "100%",
      }}
    >
      <ValidationModal
        loading={deleting}
        onClose={handleCloseModal}
        onClick={handleAccessoryDelete}
        open={openModal}
        title={"Êtes-vous sûr de vouloir supprimer cet accessoire ?"}
        paragraph={"Sa suppression est définitive."}
      />

      <div style={{ flex: "1 1 auto", height: "100%" }}>
        <AutoSizer>
          {({ width, height }) => {
            return (
              <List
                overscanRowCount={5}
                noRowsRenderer={_noRowsRenderer}
                rowCount={props?.accessories?.length || 0}
                rowHeight={80}
                rowRenderer={_rowRenderer}
                width={width}
                height={height}
              />
            );
          }}
        </AutoSizer>
      </div>
    </div>
  );
}
